import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import WarehouseComponent from '../components/ware-house.component';
import { stores } from '../../../../../../redux/stores/action';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { warehouses } from '../../../../../../redux/ware-houses/action';
import { selectWarehousesQueryItems } from '../../../../../../redux/ware-houses/selector';

const ManagementWarehouse = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const warehouseQuery = useSelector(selectWarehousesQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const storeItems = useSelector(selectStoresListItems)
const [
    selectedAddress,
    setSelectedAddress
  ] = useState<any>({

    PrimaryAddress: {},
    BillingAddress: {},
    ShippingAddress: {}

  })  
  const [
    selectedWarehouse,
    setSelectedWarehouse
  ] = useState<any>([])

  const fetchWarehouseQueryById= ()=>{
    dispatch(warehouses.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/query`,entity:'warehouses',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedWarehouse({ ...selectedWarehouse, [field]: event })
  }

const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedWarehouse({ ...selectedWarehouse, [fields[0]]: value });
    setSelectedAddress({ ...selectedAddress, [fields[0]]: value });
  }
  
  useEffect(
    () => {
        dispatch(stores.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,entity:'stores',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
                fetchWarehouseQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedWarehouse(warehouseQuery?.result?.items)
        setSelectedAddress({ 
            PrimaryAddress: warehouseQuery?.result?.items?.PrimaryAddress,
            BillingAddress: warehouseQuery?.result?.items?.BillingAddress,
            ShippingAddress: warehouseQuery?.result?.items?.ShippingAddress})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const warehouseData= {
   
        WarehouseInfo: {
            Id: selectedWarehouse?.WarehouseInfo?.Id || 0,
            WarehouseName: selectedWarehouse?.WarehouseInfo?.WarehouseName,
            WarehousePhoneNumber: selectedWarehouse?.WarehouseInfo?.WarehousePhoneNumber,
            StoreId: selectedWarehouse?.WarehouseInfo?.StoreId,
            CountryCode: selectedWarehouse?.WarehouseInfo?.CountryCode || 'INR',
          },
        PrimaryAddress:selectedAddress?.PrimaryAddress,
        IsUsePrimaryAddressAsBillingAddress: selectedWarehouse?.IsUsePrimaryAddressAsBillingAddress || false,
        BillingAddress: selectedAddress?.BillingAddress,
        IsUsePrimaryAddressAsShippingAddress: selectedWarehouse?.IsUsePrimaryAddressAsShippingAddress || false,
        ShippingAddress: selectedAddress?.ShippingAddress
      }
      if (parmas?.id > 0) {
     dispatch(warehouses.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses`,entity:'warehouses',jsonData:{
          
    Records: [
        warehouseData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(warehouses.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses`,entity:'warehouses',jsonData:{
            
        Records: [
            warehouseData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/ware-houses')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <WarehouseComponent 
          handleFormSubmit={handleFormSubmit}
          back={back}
          stores={storeItems?.result?.items}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          onInnerFormChange={handleInnerFormChange}
          selectedAddress={selectedAddress}
          selectedWarehouse={selectedWarehouse}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementWarehouse;